<template>
  <div class="about">
    <div class="article-cover">
      <img src="https://res.smoktech.com/files/e238cd2d/article2.png" alt>
    </div>
    <div class="about-content">
      <h1 class="title">About US</h1>
      <div class="article">
        <p>IVPS Tour is committed to creating the first platform to integrate trend culture with vertical social and event media, providing a one-stop experience for all the hipsters, people, players and enthusiasts. Committed to let people enjoy the fun from the online and offline activities & get help and share experience!</p>
        <p>With the IVPS Tour app you can:</p>
        <p>*Follow topics and share with like-minded people</p>
        <p>*Post ideas /pics/ videos & get feedback from fellow experts</p>
        <p>*Read what interest you & stay on top of all updates</p>
        <p>*Personalized Cover pictures to show your unique style</p>
        <p>*Chat with other members just like you</p>
        <p>We have lots of plans for update!</p>
        <p>Start and enjoy your IVPS Tour!!</p>
      </div>
      <p class="contact">Contacts Support</p>
      <p class="signature">
        <a href="mailto:ivpstour@smoktech.com">ivpstour@smoktech.com</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "About"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.about {
  /* overflow: hidden; */
  background: rgba(255, 255, 255, 0.45);
  /* width: 500px; */
  height: 720px;
  padding: 40px 0 40px 40px;
  border: 2px #ffffff solid;
  border-radius: 20px;
  box-shadow: 2px 2px 35px 2px rgba(0, 0, 0, 0.1);
}

.article-cover {
  display: none;
}

.about-content {
  height: 640px;
  overflow-y: auto;
  margin-right: -2px;
  padding-right: 20px;
}

.about-content::-webkit-scrollbar {
  width: 14px;
  height: 1px;
}
.about-content::-webkit-scrollbar-thumb {
  /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
  background: #ccc;
}
.about-content::-webkit-scrollbar-track {
  /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
  background: #ededed;
}
.title,
.contact,
.signature a {
  font-size: 20px;
  color: #252525;
}

.title {
  position: relative;
  padding: 24px 0;
}

.title::after,
.contact::after {
  content: " ";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 2px;
  background: #ccc;
  width: 76px;
}

.article p {
  margin: 24px 0;
  font-size: 16px;
  line-height: 24px;
  color: #333;
}

.contact {
  position: relative;
  margin: 65px 0 0;
  padding-bottom: 24px;
}

.signature a {
  display: inline-block;
  margin: 24px 0;
}

@media (max-width: 1024px) {
  .about {
    padding: 0;
  }

  .article-cover {
    display: inline-block;
    width: 100%;
    height: auto;
  }

  .article-cover img{
    object-fit: contain;
    width: 100%;
    height: auto;
  }

  .about-content {
    padding: 34px 40px 40px;
    text-align: left;
  }

  .title::after,
  .contact::after {
    /* width: 100%; */
  }
  @media (max-width: 750px) {
    .about {
      /* position: absolute;
      top: 78px;
      left: 0;
      width: 100%; */
      height: auto;
      background: #ffffff;
      overflow: hidden;
      border-radius: 0;
      border: none;
    }

    .about-content {
      height: auto;
    }

    .article-cover {
      /* margin: -40px 0 0 -40px; */
    }
  }
}
</style>
